import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { Currencies } from '../../core/pipe/currency.pipe';

export class BrfMortgagePrescription extends ModelBase {
  constructor(dataContext?: any) {
    super();
    this.currencyCode = Currencies.SEK;
    this.amount = new Money(this.currencyCode, null);
    if (dataContext) {
      this.id = dataContext.id;
      this.mortgageOrder = dataContext.mortgageOrder;
      this.mortgageNumber = dataContext.mortgageNumber;
      this.amount = dataContext.amount;
      this.leaseAgreementId = dataContext.leaseAgreementId;
      this.rentalObjectId = dataContext.rentalObjectId;
      this.creditInstituteId = dataContext.creditInstituteId;
      this.creditInstituteName = dataContext.creditInstituteName;
      this.fromDate = dataContext.fromDate;
      this.toDate = dataContext.toDate;
    }

    Object.defineProperties(this, {
      _fromDate: { writable: true, enumerable: false },
      _toDate: { writable: true, enumerable: false },
    });
  }

  currencyCode: string;
  mortgageNumber: string;
  mortgageOrder: number;
  amount: Money;
  creditInstituteId: string;
  creditInstituteName: string;
  leaseAgreementId: string;
  rentalObjectId: string;

  private _fromDate: LocalDate;
  get fromDate(): LocalDate {
    return this._fromDate;
  }
  set fromDate(value: LocalDate) {
    this._fromDate = LocalDate.fromDate(value);
  }

  private _toDate: LocalDate;
  get toDate(): LocalDate {
    return this._toDate;
  }
  set toDate(value: LocalDate) {
    this._toDate = LocalDate.fromDate(value);
  }

  toJSON() {
    let json = Object.assign({}, this);
    json.fromDate = this.fromDate;
    json.toDate = this.toDate;
    return json;
  }
}
